import moment from 'moment'

export default {
  name: 'transport',
  methods: {
    getEmptyRequestObject (requestDefinition, forCopy) {
      var requestObject = null
      if (requestDefinition) {
        requestObject = []
        for (var definition of requestDefinition) {
          var object = {}
          object.id = definition.id // String

          this.setEmptyRequestObjectAttributes(object, definition, forCopy)

          requestObject.push(object)
        }
      }
      return requestObject
    },
    setEmptyRequestObjectAttributes (object, definition, forCopy) {
      object.condChildId = null // String
      object.textValue = null // String
      object.domainKey = null // String
      object.domainValue = [] // Array
      object.languageValue = [] // Array
      object.complexDomainValue = null // Array

      // set default value for choice fields
      if (this.isChoice(definition)) {
        if (definition.validation.domain) {
          for (var i = 0; i < definition.validation.domain.length; i++) {
            if (definition.validation.domain[i].defvalue) {
              object.domainValue.push(definition.validation.domain[i])
            }
          }
        }        
      }

      // set all languages with empty values
      if (this.isMultiLanguage(definition)) {
        object.languageValue = this.getEmptyRequestMultilanguageObject(definition)
      }

      // definition is / not repeatable group?
      if (this.isRepeatableGroup(definition) && !forCopy) {
        object.children = [] // Array
      } else {
        object.children = this.getEmptyRequestObject(definition.children, forCopy) // Array
      }
    },
    getEmptyRequestMultilanguageObject (definition) {
      var result = []

      for (var j = 0; j < definition.validation.language.length; j++) {
        result.push({
          key: definition.validation.language[j].key,
          value: ''
        })
      }

      return result
    },
    modifyRequestSearcherHeaderValue (requestSearcherHeader, id, order) {
      if (requestSearcherHeader) {
        for (var i = 0; i < requestSearcherHeader.length; i++) {
          if (requestSearcherHeader[i].id === id) {
            requestSearcherHeader[i].order = order
          } else {
            requestSearcherHeader[i].order = null
          }
        }
      }

      return requestSearcherHeader
    },
    getSearcherAliasByType (requestSearcherHeader, type) {
      var result = ''
      if (requestSearcherHeader) {
        var found = false
        for (var i = 0; i < requestSearcherHeader.length && !found; i++) {
          if (requestSearcherHeader[i].type === type) {
            result = requestSearcherHeader[i].id
            found = true
          }
        }
      }

      return result
    },
    getSearcherColumnValue (requestIdValue, id) {
      var result = ''
      if (requestIdValue) {
        var found = false
        for (var i = 0; i < requestIdValue.length && !found; i++) {
          if (requestIdValue[i].id === id) {
            result = requestIdValue[i].value
            found = true
          }
        }
      }

      return result
    },
    getRequestDefinitionById (id, requestDefinition) {
      var result = null

      if (requestDefinition) {
        var found = false
        for (var i = 0; i < requestDefinition.length && !found; i++) {
          if (requestDefinition[i].id === id) {
            result = requestDefinition[i]
            found = true
          }
          if (!found) {
            result = this.getRequestDefinitionById(id, requestDefinition[i].children)
            if (result) {
              found = true
            }
          }
        }
      }
      return result
    },
    getRequestObjectById (id, requestObject) {
      var result = null

      if (requestObject) {
        var found = false
        for (var i = 0; i < requestObject.length && !found; i++) {
          if (requestObject[i]) {
            if (requestObject[i].id === id) {
              result = requestObject[i]
              found = true
            }
            if (!found) {
              if (requestObject[i].children) {
                var childrenResult = this.getRequestObjectById(id, requestObject[i].children)
                if (childrenResult) {
                  result = childrenResult
                  found = true
                }
              }
            }
          }
        }
      }

      return result
    },
    getRequestObjectByAliasName (aliasName, requestObject) {
      var result = null

      if (requestObject) {
        var found = false
        for (var i = 0; i < requestObject.length && !found; i++) {
          if (requestObject[i].id.endsWith('_' + aliasName)) {
            result = requestObject[i]
            found = true
          }
          if (!found) {
            if (requestObject[i].children) {
              var childrenResult = this.getRequestObjectByAliasName(aliasName, requestObject[i].children)
              if (childrenResult) {
                result = childrenResult
                found = true
              }
            }
          }
        }
      }

      return result
    },
    // Decidim el mode 'edit/no-edit' en funció del mode de vista general i la definició del camp
    // @modeView: String mode de vista. new: Crear; modify: Modificar; lookup: Lectura
    // @action: String acció a realitzar. C: Create; U: Update; R: ReadOnly
    // @reqObj: tenir en compte reqObj.editable
    // @return boolean: 'true' camp editable; 'false' camp no editable
    isEditable (modeView, reqDef, reqObj) {
      var result = false

      if (reqObj && reqObj.editable === false) {
        result = false

      } else {
        var modeViewLC = null
        if (modeView) {
          modeViewLC = modeView.toLowerCase()
        }
  
        var actionLC = null
        if (reqDef && reqDef.action) {
          actionLC = reqDef.action.toLowerCase()
        }
  
        if ((!modeView || modeViewLC === 'table' || modeViewLC === 'gallery') && actionLC !== 'r') {
          result = true
        } else if (modeViewLC === 'new') {
          if (actionLC === 'c' || actionLC === 'u') {
            result = true
          } else {
            result = false
          }
        } else if (modeViewLC === 'modify') {
          if (actionLC === 'u') {
            result = true
          } else {
            result = false
          }
        } else if (modeViewLC === 'lookup') {
          result = false
        } else {
          result = false
        }
      }

      return result
    },
    // Decidim si el camp és obligatori
    // @reqDef: objecte de definició
    // @return boolean: 'true' camp obligatori; 'false' camp no obligatori
    isRequired (reqDef) {
      var result = false

      if (reqDef.validation && reqDef.validation.mandatory) {
        if (reqDef.validation.mandatory.min && reqDef.validation.mandatory.min > 0) {
          result = true
        }
      }

      return result
    },
    getChoiceKeys (object) {
      var result = ''
      if (object && object.domainValue && object.domainValue.length > 0) {
        for (var i = 0; i < object.domainValue.length; i++) {
          var multiChoiceValue = ''
          if (result !== '') {
            multiChoiceValue = ','
          }
          if (object.domainValue[i] && object.domainValue[i].key) {
            result += multiChoiceValue + object.domainValue[i].key
          }          
        }
      }

      return result
    },
    getObjectTextValue (visualDef, definition, object, language) {
      var result = ''

      if (object) {
        if ((
            definition.type === 'text' || definition.type === 'longText' || definition.type === 'html' || definition.type === 'id' 
            || definition.type === 'code' || definition.type === 'date'  || definition.type === 'datetime' || definition.type === 'duration' 
            || definition.type === 'cron' || definition.type === 'linkId' || definition.type === 'number' || definition.type === 'file'
            || definition.type === 'pdf' || definition.type === 'time'
        )) {
          var value = null
          if (this.isMultiLanguage(definition)) {
            value = this.getLanguageValue(object, language)
          } else {
            value = object.textValue
          }
          if (definition.type === 'duration' && value && value !== '') {
            value += 'h'
          }
          if (value && definition.type === 'file') {
            value = value.substring(value.lastIndexOf('/') + 1)
          }
          result = (value && value.trim() !== '') ? value : ''
        } else if (definition.type === 'dateInterval' || definition.type === 'numInterval') {
          var myRegexp = /\[([^\]]+)\]/g
          var match = myRegexp.exec(object.textValue)
          while (match != null) {
            var dateResult = ''
            if (result !== '') {
              dateResult = ' - '
            }
            result += dateResult + match[0]
            match = myRegexp.exec(object.textValue)
          }
        } else if (definition.type === 'mono-choice') {
          if (object.domainValue && object.domainValue.length > 0) {
            if (visualDef && visualDef.class && visualDef.class.search('icons') >= 0) {
              result = '<i class="sherpa-icon icon-' + object.domainValue[0].key + '"></i> '
            }
            result += object.domainValue[0].value
          } else {
            result = ''
          }
        } else if (definition.type === 'multi-choice') {
          if (object.domainValue && object.domainValue.length > 0) {
            for (var i = 0; i < object.domainValue.length; i++) {
              var multiChoiceValue = ''
              if (result !== '') {
                multiChoiceValue = '<br/>'
              }
              if (visualDef && visualDef.class && visualDef.class.search('icons') >= 0) {
                result += '<i class="sherpa-icon icon-' + object.domainValue[i].key + '"></i> '
              }
              result += multiChoiceValue + object.domainValue[i].value
            }
          } else {
            result = ''
          }
        }
      }

      return result
    },
    validateTextFormat (isRequired, format, textValue) {
      const XRegExp = require('xregexp')
      var text = textValue
      var result = null
      //-- condition only if is required
      if ((!text || text.trim() === '') && format.lengthMin > 0 && isRequired) {
        result = 'errorLengthMin'
      } else if (text && text !== '') {
        text = text.trim()
        if (text.length < format.lengthMin) {
          result = 'errorLengthMin'
        } else if (text.length > format.lengthMax) {
          result = 'errorLengthMax'
        } else if (format.regExp && format.regExp !== '') {
          var eRegex = XRegExp(format.regExp)
          var htext = text.replace(/\n/g, '')
          if (!eRegex.test(htext, eRegex)) {
            result = 'errorRegExp'
          } else {
            var matches = htext.match(eRegex)
            if (!matches || matches.length < 1) {
              result = 'errorRegExp'
            } else if (matches[0] !== htext) {
              result = 'errorRegExp'
            }
          }
        }
      }

      return result
    },
    validateNumberFormat (isRequired, format, textValue) {
      const XRegExp = require('xregexp')
      var numberText = textValue
      var result = null
      //-- condition only if is required
      if (numberText && numberText !== '') {
        numberText = numberText.trim()
        if (format.regExp && format.regExp !== '') {
          var eRegex = XRegExp(format.regExp)
          var htext = numberText.replace(/\n/g, '')
          if (!eRegex.test(htext, eRegex)) {
            result = 'errorRegExp'
          } else {
            var matches = htext.match(eRegex)
            if (!matches || matches.length < 1) {
              result = 'errorRegExp'
            } else if (matches[0] !== htext) {
              result = 'errorRegExp'
            } else {
              //-- check number range
              var numberFloat = parseFloat(numberText)
              if (format.lengthMin !== null && numberFloat < format.lengthMin) {
                result = 'errorNumberMin'
              } else if (format.lengthMax !== null && numberFloat > format.lengthMax) {
                result = 'errorNumberMax'
              }
            }
          }
        }
      }

      return result
    },
    validateDateFormat (definition, dateValue) {
      var result = null

      try {
        var date = moment(dateValue).format(this.getDateFormat(definition.validation.format.regExp))
        if (date === 'Invalid date') {
          result = 'errorDateFormat'
        }
      } catch (e) {
        result = 'errorDateFormat'
      }

      return result
    },
    validateNumIntervalFormat (definition, numValue) {
      var result = null

      try {
        if (isNaN(numValue)) {
          result = 'errorNumIntervalFormat'
        }
      } catch (e) {
        result = 'errorNumIntervalFormat'
      }

      return result
    },
    getDate (dateStr, definition) {
      var result = null
      if (dateStr) {
        result = moment(dateStr, definition.validation.format.regExp.replace(/d/g, 'D').replace(/y/g, 'Y')).toDate()
      }
      return result
    },
    getDateStr (date, definition) {
      var result = ''
      if (date) {
        result = moment(date).format(this.getDateFormat(definition.validation.format.regExp))
      }
      return result
    },
    validateMandatory (definition, object) {
      var result = null
      if (definition.validation && definition.validation.mandatory) {
        var mandatory = definition.validation.mandatory
        if (
          definition.type === 'text' || definition.type === 'longText' || definition.type === 'html' || definition.type === 'image' 
          || definition.type === 'cron' || definition.type === 'number' || definition.type === 'pdf' || definition.type === 'file'
        ) {
          if (this.isMultiLanguage(definition)) {
            if (mandatory.min > 0 && !this.allMandatoryLanguagesFilled(definition, object)) {
              result = 'errorMandatoryLanguageMinOne'
            } else if (this.someLanguageFilled(object) && !this.allMandatoryLanguagesFilled(definition, object)) {
              result = 'errorMandatoryLanguageMinOne'
            }
          } else {
            var text = object.textValue
            if (mandatory.min > 0 && (!text || text.trim() === '')) {
              result = 'errorMandatoryMinOne'
            }
          }
        } else if (this.isDate(definition)) {
          var date = object.textValue
          if (mandatory.min > 0 && (!date || date.trim() === '')) {
            result = 'errorMandatoryMinOne'
          }
        } else if (this.isChoice(definition)) {
          var domain = object.domainValue
          result = this.validateMandatoryMinMax(mandatory, domain)
        } else if (definition.type === 'numInterval') {
          var numInterval = object.textValue
          if (mandatory.min > 0 && (!numInterval || numInterval.trim() === '')) {
            result = 'errorMandatoryMinOne'
          }
        } else if (this.isRepeatableGroup(definition)) {
          var responses = object.children
          result = this.validateMandatoryMinMax(mandatory, responses)
        }
      }

      return result
    },
    validateMandatoryMinMax (mandatory, domain) {
      var result = null
      if (mandatory.min > 0 && (!domain || domain.length < mandatory.min)) {
        if (mandatory.min === 1) {
          result = 'errorMandatoryMinOne'
        } else {
          result = 'errorMandatoryMin'
        }
      } else if (mandatory.max > 0 && (!domain || domain.length > mandatory.max)) {
        if (mandatory.max === 1) {
          result = 'errorMandatoryMaxOne'
        } else {
          result = 'errorMandatoryMax'
        }
      }

      return result
    },
    validateHtmlFormat (definition, format, htmlValue) {
      var result = null
      // no content html validation
      // result = 'errorHtmlFormat'
      return result
    },
    validateImageFormat (definition, format, imageValue) {
      var result = null
      // no content image validation
      // result = 'errorImageFormat'
      return result
    },
    validateFileFormat (definition, format, imageValue) {
      var result = null
      // no content file validation
      // result = 'errorFileFormat'
      return result
    },
    validatePdfFormat (definition, format, imageValue) {
      var result = null
      // no content pdf validation
      // result = 'errorPdfFormat'
      return result
    },
    validateQuestFlow (requestDefinition, requestObject, id) {
      var result = true

      if (requestDefinition) {
        var found = false
        for (var i = 0; i < requestDefinition.length && !found; i++) {
          if (requestDefinition[i].validation && requestDefinition[i].validation.questFlow) {
            var questFlow = requestDefinition[i].validation.questFlow
            for (var j = 0; j < questFlow.length && !found; j++) {
              var questFlowItem = questFlow[j]
              if (questFlowItem.gotoId === id) {
                found = true
                var questflowId = requestDefinition[i].id
                var reqObj = this.getRequestObjectById(questflowId, requestObject)
                if (reqObj) {
                  if (reqObj.domainValue && reqObj.domainValue.length > 0) {
                    for (var k = 0; k < reqObj.domainValue.length; k++) {
                      if (reqObj.domainValue[k].key !== questFlowItem.selectedValue) {
                        result = false
                      }
                    }
                    // search for * if result === false
                    if (!result) {
                      for (var l = 0; l < reqObj.domainValue.length; l++) {
                        if (questFlowItem.selectedValue === '*') {
                          result = true
                        }
                      }
                    }
                  } else {
                    // empty values
                    var resetObj = this.getRequestObjectById(id, requestObject)
                    var resetDef = this.getRequestDefinitionById(id, requestDefinition)
                    if (resetDef) {
                      this.setEmptyRequestObjectAttributes(resetObj, resetDef, true)
                    }
                    result = false
                  }
                }
              }
            }
          }
          if (!found) {
            result = this.validateQuestFlow(requestDefinition[i].children, requestObject, id)
            if (!result) {
              found = true
            }
          }
        }
      }
      return result
    },
    validateForm (modeView, requestDefinition, requestObject, isAddForm, allRequestObject) {
      var errors = {
        id: [],
        errorsNumber: 0
      }
      if (!allRequestObject) {
        allRequestObject = []
      }
      for (var i = 0; i < requestObject.length; i++) {
        var object = requestObject[i]
        allRequestObject.push(object)
        var definition = this.getRequestDefinitionById(object.id, requestDefinition, requestObject)

        if (this.visibleIfConditional(definition, allRequestObject)) {
          if (definition.type !== 'group' && this.isEditable(modeView, definition, object) && this.validateQuestFlow(requestDefinition, requestObject, definition.id)) {
            // validate mandatory
            var result = this.validateMandatory(definition, object)          
            if (result) {
              errors.id.push(definition.id)
              errors.errorsNumber += 1
            } else {
              // validate by field definition type
              if (
                definition.type === 'text' || definition.type === 'longText' || definition.type === 'html' || definition.type === 'id' 
                || definition.type === 'code' || definition.type === 'image' || definition.type === 'file' || definition.type === 'linkId'
                || definition.type === 'pdf'
              ) {
                if (this.isMultiLanguage(definition)) {
                  for (var j = 0; j < definition.validation.language.length && !result; j++) {
                    var language = definition.validation.language[j]
                    if (definition.type === 'text' || definition.type === 'longText') {
                      result = this.validateTextFormat(language.mandatory, language.format, this.getLanguageValue(object, definition.validation.language[j].key))
                    } else if (definition.type === 'html') {
                      result = this.validateHtmlFormat(definition, language.format, this.getLanguageValue(object, definition.validation.language[j].key))
                    } else if (definition.type === 'image') {
                      result = this.validateImageFormat(definition, language.format, this.getLanguageValue(object, definition.validation.language[j].key))
                    } else if (definition.type === 'file') {
                      result = this.validateFileFormat(definition, language.format, this.getLanguageValue(object, definition.validation.language[j].key))
                    } else if (definition.type === 'pdf') {
                      result = this.validatePdfFormat(definition, language.format, this.getLanguageValue(object, definition.validation.language[j].key))
                    }
                  }
                } else {
                  if (definition.type === 'text' || definition.type === 'longText') {
                    result = this.validateTextFormat(this.isRequired(definition), definition.validation.format, object.textValue)
                  } else if (definition.type === 'html') {
                    result = this.validateHtmlFormat(definition, definition.validation.format, object.textValue)
                  } else if (definition.type === 'image') {
                    result = this.validateImageFormat(definition, definition.validation.format, object.textValue)
                  } else if (definition.type === 'file') {
                    result = this.validateFileFormat(definition, definition.validation.format, object.textValue)
                  } else if (definition.type === 'pdf') {
                    result = this.validatePdfFormat(definition, definition.validation.format, object.textValue)
                  }
                }
  
                if (result) {
                  errors.id.push(definition.id)
                  errors.errorsNumber += 1
                }
              } else if ((definition.type === 'date' || definition.type === 'datetime') && object.textValue) {
                result = this.validateDateFormat(definition, this.getDate(object.textValue, definition))
                if (result) {
                  errors.id.push(definition.id)
                  errors.errorsNumber += 1
                }
              } else if (definition.type === 'dateInterval' && object.textValue) {
                var myRegexp = /\[([^\]]+)\]/g
                var match = myRegexp.exec(object.textValue)
                while (match) {
                  result = this.validateDateFormat(definition, this.getDate(match[0], definition))
                  if (result) {
                    errors.id.push(definition.id)
                    errors.errorsNumber += 1
                  }
                  match = myRegexp.exec(object.textValue)
                }
              } else if (definition.type === 'numInterval' && object.textValue) {
                var myRegexp = /\[([^\]]+)\]/g
                var match = myRegexp.exec(object.textValue)
                while (match) {
                  result = this.validateNumIntervalFormat(definition, parseInt(match[1]))
                  if (result) {
                    errors.id.push(definition.id)
                    errors.errorsNumber += 1
                  }
                  match = myRegexp.exec(object.textValue)
                }
              }
            }
          } else if (this.isRepeatableGroup(definition) && this.validateQuestFlow(requestDefinition, requestObject, definition.id)) {
            result = this.validateMandatory(definition, object)
            if (result) {
              errors.id.push(definition.id)
              errors.errorsNumber += 1
            }
          }
  
          // validate group children if isAddForm event or is normal group
          if (isAddForm || (definition.type === 'group' && object.children && !this.isRepeatableGroup(definition) && this.validateQuestFlow(requestDefinition, requestObject, definition.id))) {
            var childrenErrors = this.validateForm(modeView, requestDefinition, object.children, null, allRequestObject)
            errors.id = errors.id.concat(childrenErrors.id)
            errors.errorsNumber += childrenErrors.errorsNumber
          }
        }
      }

      return errors
    },
    visibleIfConditional (definition, requestObject) {
      let result = true
      
      if (definition && definition.validation && definition.validation.condParentId) {
        let conditionalObj = this.getRequestObjectById(definition.validation.condParentId, requestObject)
        if (conditionalObj && conditionalObj.domainValue && conditionalObj.domainValue[0]) {
          let conditionalKey = conditionalObj.domainValue[0].key
          if (conditionalKey) {
            if (definition.validation.condParentValue) {
              let parts = definition.validation.condParentValue.split(',')
              result = parts.includes(conditionalKey)
            // is '*' case  
            } else {
              result = true
            }
          } else {
            result = false
          }          
        } else {
          result = false
        }
      }

      return result
    },
    getAliasTypeId (requestDefinition) {
      return this.getAliasType(requestDefinition, 'id')
    },
    getAliasTypeCode (requestDefinition, searchOnRepeatableGroups) {
      return this.getAliasType(requestDefinition, 'code', searchOnRepeatableGroups)
    },
    getAliasTypeLinkId (requestDefinition) {
      return this.getAliasType(requestDefinition, 'linkId')
    },
    getAliasType (requestDefinition, type, searchOnRepeatableGroups) {
      var aliasType = null

      if (requestDefinition) {
        var found = false
        for (var i = 0; i < requestDefinition.length && !found; i++) {
          var reqDef = requestDefinition[i]
          if (reqDef.type === type) {
            aliasType = reqDef.id
            found = true
          }
          if (
            !found
            && (
              (searchOnRepeatableGroups === undefined || searchOnRepeatableGroups === null)
              ||
              (searchOnRepeatableGroups === true)
              ||
              (searchOnRepeatableGroups === false && (!reqDef.validation || (reqDef.validation && !reqDef.validation.repeatable)))
            )
          ) {
            aliasType = this.getAliasType(reqDef.children, type, searchOnRepeatableGroups)
            if (aliasType) {
              found = true
            }
          }
        }
      }

      return aliasType
    },
    getIdValue (requestDefinition, requestObject) {
      var idValue = null
      var aliasId = this.getAliasTypeId(requestDefinition)
      if (aliasId) {
        var aliasIdValue = this.getRequestObjectById(aliasId, requestObject)
        if (aliasIdValue && aliasIdValue.textValue) {
          idValue = aliasIdValue.textValue
        }
      }
      return idValue
    },
    modifyRequestObject (requestObject, newObject) {
      var result = requestObject

      if (result) {
        if (result.id === newObject.id) {
          result = newObject
        } else if (result.children && result.children.length > 0) {
          for (var i = 0; i < result.children.length; i++) {
            result.children[i] = this.modifyRequestObject(result.children[i], newObject)
          }
        }
      }

      return result
    },
    changeRequestDefinition (idToChange, requestDefinition, newDefinition) {
      var result = requestDefinition

      if (result) {
        if (result.id === idToChange) {
          result = newDefinition
        } else if (result.children && result.children.length > 0) {
          for (var i = 0; i < result.children.length; i++) {
            result.children[i] = this.changeRequestDefinition(idToChange, result.children[i], newDefinition)
          }
        }
      }

      return result
    },
    changeRequestObject (idToChange, requestObject, newObject) {
      var result = requestObject

      if (result) {
        if (result.id === idToChange) {
          result = newObject
        } else if (result.children && result.children.length > 0) {
          for (var i = 0; i < result.children.length; i++) {
            var child = result.children[i]
            result.children[i] = this.changeRequestObject(idToChange, child, newObject)
          }
        }
      }

      return result
    },
    changeConditionalObjects (objs, conditionalFieldId, newReqObj) {
      // remove conditional field or previous loaded fields
      this.removeConditionalObjects(objs, conditionalFieldId, newReqObj)
    },
    removeConditionalObjects (objs, conditionalFieldId, newReqObj) {
      var replacePosition = -1
      if (objs) {
        var childReplaced = false
        for (var i = 0; i < objs.length && !childReplaced; i++) {
          var obj = objs[i]
          if (obj.id === conditionalFieldId || obj.conditionalFieldId === conditionalFieldId) {
            objs.splice(i, 1)
            if (replacePosition === -1) {
              replacePosition = i
            }
            i -= 1
          } else {
            childReplaced = this.removeConditionalObjects(obj.children, conditionalFieldId, newReqObj)
          }
        }
        if (!childReplaced && replacePosition > -1 && newReqObj) {
          for (var j = 0; j < newReqObj.length; j++) {
            var newObj = newReqObj[j]
            if (newObj) {
              newObj.conditionalFieldId = conditionalFieldId
              objs.splice(replacePosition, 0, newObj)
              replacePosition += 1
            }
          }
        }
      }
      return (replacePosition > -1)
    },
    isRepeatableGroup (reqDef) {
      return reqDef.type === 'group' && reqDef.validation && reqDef.validation.repeatable
    },
    isMultiLanguage (reqDef) {
      return reqDef.validation && reqDef.validation.multiLang
    },
    definitionMultiLanguageGroup (requestDefinition) {
      var result = null
      for (var i = 0; i < requestDefinition.length && !result; i++) {
        if (this.isMultiLanguage(requestDefinition[i])) {
          result = requestDefinition[i]
        }
        if (!result && requestDefinition[i].children) {
          result = this.definitionMultiLanguageGroup(requestDefinition[i].children)
        }
      }

      return result
    },
    isChoice (reqDef) {
      return (reqDef.type === 'mono-choice' || reqDef.type === 'multi-choice') && reqDef.validation
    },
    isDate (reqDef) {
      return (reqDef.type === 'date' || reqDef.type === 'datetime' || reqDef.type === 'dateInterval' || reqDef.type === 'time' || reqDef.type === 'duration')
    },
    isForTranslate (reqDef, apiparams) {
      return reqDef.validation.translate && reqDef.validation.language && reqDef.validation.language.length > 1 && apiparams.translateKey
    },
    isForCopy (reqDef) {
      return reqDef.validation.language && reqDef.validation.language.length > 1
    },
    maxRepeatableGroupElements (reqDef, elements) {
      var result = false
      if (elements) {
        if (reqDef.validation.mandatory.max <= elements.length) {
          result = true
        }
      }

      return result
    },
    getFirstMandatoryMultiLanguage (language) {
      var result = null
      for (var i = 0; i < language.length && !result; i++) {
        if (language[i].mandatory) {
          result = language[i]
        }
      }

      return result
    },
    setLanguageValue (object, textValue, language) {
      var found = false
      if (object.languageValue) {
        for (var i = 0; i < object.languageValue.length && !found; i++) {
          if (object.languageValue[i].key.toLowerCase() === language.toLowerCase()) {
            object.languageValue[i].value = textValue
            found = true
          }
        }
      }
      return object
    },
    getLanguage (key, definition) {
      var result = null
      var found = false
      for (var i = 0; i < definition.validation.language.length && !found; i++) {
        if (definition.validation.language[i].key.toLowerCase() === key.toLowerCase()) {
          result = definition.validation.language[i]
          found = true
        }
      }

      return result
    },
    getLanguageValue (object, language) {
      var result = ''
      if (object && object.languageValue) {
        var found = false
        for (var i = 0; i < object.languageValue.length && !found; i++) {
          if (object.languageValue[i].key && language) {
            if (object.languageValue[i].key.toLowerCase() === language.toLowerCase()) {
              result = object.languageValue[i].value
              found = true
            }
          }          
        }
      }

      return result.trim()
    },
    allMandatoryLanguagesFilled (definition, object) {
      var result = true
      for (var i = 0; i < definition.validation.language.length && result; i++) {
        var languageValue = this.getLanguageValue(object, definition.validation.language[i].key)
        if (definition.validation.language[i].mandatory && languageValue === '') {
          result = false
        }
      }

      return result
    },
    someLanguageFilled (object) {
      var result = false
      if (object.languageValue) {
        for (var i = 0; i < object.languageValue.length && !result; i++) {
          if (object.languageValue[i].value !== '') {
            result = true
          }
        }
      }

      return result
    },
    getConditionalDefinition (keys, parentId, conditionalDefinitions) {
      var result = null

      if (conditionalDefinitions && keys) {
        // One definition for all responses
        if (conditionalDefinitions.length === 1 && conditionalDefinitions[0].validation.condParentId === parentId && !conditionalDefinitions[0].validation.condParentValue) {
          var definition = conditionalDefinitions[0]
          this.setConditionalDomains(definition, keys)
          result = definition
        // One definition by response
        } else {
          for (var j = 0; j < conditionalDefinitions.length && !result; j++) {
            var def = conditionalDefinitions[j]
            if (
              def.validation &&
              def.validation.condParentId === parentId &&
              this.isConditionalValue(def.validation.condParentValue, keys)
            ) {
              result = def
              this.setConditionalDomains(result, keys)              
            }
          }
        }
      }
      return result
    },
    isConditionalValue (condParentValue, keys) {
      let result = false

      // multiple values
      if (condParentValue.indexOf(',') > -1) {
        result = condParentValue.split(',').includes(keys)
      // one value
      } else {
        result = condParentValue === keys
      }

      // '*' case
      result = result || condParentValue === '*'

      return result
    },
    setConditionalDomains (definition, keys) {
      // if type 'choice', modify domainValues with keys
      if (definition.type === 'mono-choice' || definition.type === 'multi-choice') {
        // save original domain values
        if (!definition.validation.originalDomain) {
          definition.validation.originalDomain = JSON.parse(JSON.stringify(definition.validation.domain))
        }
        var newDomain = []
        if (definition.validation.originalDomain) {
          for (var i = 0; i < definition.validation.originalDomain.length; i++) {
            var domain = definition.validation.originalDomain[i]
            if (
              (domain.condParentValue && keys && domain.condParentValue.toLowerCase() === keys.toLowerCase())
              || 
              domain.condParentValue === null
            ) {
              newDomain.push(domain)            
            }
          }
        }
        definition.validation.domain = newDomain        
      }
      if (definition.children && definition.type !== 'conditional') {
        for (var j = 0; j < definition.children.length; j++) {
          this.setConditionalDomains(definition.children[j], keys)
        }
      }
    },
    getDataChart (chartValue) {
      var result = {}
      var headers = chartValue.header
      var dataHeader = []
      for (var i = 0; i < headers.length; i++) {
        dataHeader.push(headers[i].label)
      }

      var dataResult = [dataHeader]
      for (var j = 0; j < chartValue.data.length; j++) {
        var dataArray = chartValue.data[j]
        var dataArrayResult = []
        for (var k = 0; k < dataArray.length; k++) {
          var dataArrayValue = dataArray[k]
          if (headers[k].type === 'date') {
            dataArrayResult.push(moment(dataArrayValue, 'DD/MM/YYYY').toDate())
          } else if (headers[k].type === 'datetime') {
            dataArrayResult.push(moment(dataArrayValue, 'DD/MM/YYYY HH:mm').toDate())
          } else {
            dataArrayResult.push(dataArrayValue)
          }
        }
        dataResult.push(dataArrayResult)
      }
      result.chartData = dataResult

      return result
    },
    getCheckedDomainValues (domainValues, domain) {
      var checkedDomainValues = null

      if (domainValues && domainValues.length > 0) {
        for (var i = 0; i < domainValues.length; i++) {
          var domainValue = domainValues[i]
          var domainValueFound = false
          for (var j = 0; j < domain.length && !domainValueFound; j++) {
            var domainKey = domain[j].key
            if (domainValue.key === domainKey) {
              if (!checkedDomainValues) {
                checkedDomainValues = []
              }
              checkedDomainValues.push(domainValue)
              domainValueFound = true
            }
          }
        }
      }

      return checkedDomainValues
    },
    getDateFormat (format) {
      return format.replace(new RegExp('y', 'g'), 'Y').replace(new RegExp('d', 'g'), 'D')
    },
    getDomainValue (domainValues, key) {
      var result = null
      if (key) {
        for (var i = 0; i < domainValues.length && !result; i++) {
          var domain = domainValues[i]
          if (domain.key === key) {
            result = domain
          }
        }
      }
      return result
    },
    getRepeatableGroupCode (object, definition) {
      var result = null
      var requestObjectCode = this.getRequestObjectById(
        this.getAliasTypeCode([definition]),
        [object]
      )
      if (requestObjectCode) {
        result = requestObjectCode.textValue
      }
      return result
    },
    getFamilyCategory(name) {
      var result = null
      var nameParts = name.split('_')
      if (nameParts && nameParts.length === 3) {
        result = nameParts[0] + '_' + nameParts[1] + '_'
      }
      return result
    },
    allDefinitionReadable(reqDef) {
      let result = true
      if (reqDef) {
        for (let i = 0; i < reqDef.length && result; i++) {
          result = result && (reqDef[i].action === 'R')
          if (result) {
            result = result && this.allDefinitionReadable(reqDef[i].children)
          }
        }
      }
      return result
    }
  }
}
